import { jsxs as h, jsx as e } from "react/jsx-runtime";
import a from "react";
import { M as S, g as T } from "../chunks/mask.38d91945.js";
import r, { css as d } from "styled-components";
import { _ as $, h as m, b as M, a as K, i as L } from "../chunks/vendor_rango__tokens.38ee67b0.js";
import { R as U } from "../chunks/index.cff5baaf.js";
const i = r.label.withConfig({
  displayName: "Label",
  componentId: "sc-1rv0q0n-0"
})(["", " color:var(--text-label-color);"], $), l = r.div.withConfig({
  displayName: "InputContainer",
  componentId: "sc-1rv0q0n-1"
})(["display:flex;align-items:center;height:var(--size-8x);border:var(--default-border-width) solid var(--elements-border-color);border-radius:var(--default-border-radius);padding:var(--spacing-none) var(--spacing-2x);cursor:text;box-sizing:border-box;", " color:", ";", " ::placeholder{color:var(--text-placeholder-color);}transition-property:background-color;transition-timing-function:var(--curve-productive-exit);transition-duration:var(--duration-fast-01);&:hover:not(:focus-within){", " border-color:transparent;transition-timing-function:var(--curve-productive-entrance);}"], m, ({
  $filled: o
}) => o ? "var(--active-placeholder-color)" : "var(--text-placeholder-color)", ({
  $clickedFocus: o
}) => !o && d(["&:focus-within{", " outline-offset:2px;}&:hover{outline:transparent;}"], M), K), V = r.span.withConfig({
  displayName: "Prefix",
  componentId: "sc-1rv0q0n-2"
})(["margin-right:var(--spacing-1x);"]), j = r.input.withConfig({
  displayName: "Input",
  componentId: "sc-1rv0q0n-3"
})(["align-self:baseline;padding:var(--spacing-none);width:100%;height:calc(100% - 1px);border:var(--border-width-none);outline:transparent;background-color:transparent;", " color:inherit;&:-webkit-autofill{-webkit-background-clip:text;color:green !important;}&:autofill{color:green !important;}"], m), z = r.span.withConfig({
  displayName: "Suffix",
  componentId: "sc-1rv0q0n-4"
})(["margin-left:var(--spacing-1x);"]), b = r(U).withConfig({
  displayName: "Icon",
  componentId: "sc-1rv0q0n-5"
})(["padding-left:var(--spacing-1x);"]), p = r.span.withConfig({
  displayName: "SupportText",
  componentId: "sc-1rv0q0n-6"
})(["", " color:var(--text-support-text-color);"], L), P = r.div.withConfig({
  displayName: "FormControl",
  componentId: "sc-1rv0q0n-7"
})(["display:flex;flex-direction:column;width:100%;gap:var(--spacing-1x);&:focus-within{", "{color:var(--active-label-color);}", "{border-color:var(--active-border-color);}}", " ", "}"], i, l, ({
  $disabled: o
}) => o && d(["opacity:var(--opacity-low);pointer-events:none;", "{color:var(--disabled-label-color);}", "{border-color:var(--disabled-border-color);color:var(--disabled-placeholder-color);::placeholder{color:var(--disabled-placeholder-color);}}", "{color:var(--disabled-support-text-color);}"], i, l, p), ({
  $error: o
}) => o && d(["", "{color:var(--negative-label-color) !important;}", "{border-color:var(--negative-border-color) !important;color:var(--negative-placeholder-color) !important;::placeholder{color:var(--negative-placeholder-color) !important;}}", "{color:var(--negative-support-text-color) !important;}", "{color:var(--negative-icon-color) !important;}"], i, l, p, b)), E = a.forwardRef(({
  value: o = "",
  disabled: c = !1,
  error: u = !1,
  label: x = "",
  placeholder: I = "",
  supportText: w = "",
  maskType: s = "default",
  prefix: v,
  suffix: f,
  onChange: n,
  inputProps: y,
  ..._
}, C) => {
  const k = a.useRef(null), [N, g] = a.useState(!1), [R, O] = a.useState((o == null ? void 0 : o.length) > 0);
  return a.useEffect(() => {
    s === S[8] && n && n({
      target: {
        value: "R$ 0,00"
      }
    });
  }, [s]), /* @__PURE__ */ h(P, { $disabled: c, $error: u, "data-testid": "rango-input-text", "data-rango-component": "rango-input-text", "data-is-rango": !0, children: [
    /* @__PURE__ */ e(i, { children: x }),
    /* @__PURE__ */ h(l, { ref: C, $filled: R, $clickedFocus: N, children: [
      v && /* @__PURE__ */ e(V, { children: v }),
      /* @__PURE__ */ e(j, { ref: k, ..._, ...y, placeholder: I, disabled: c, value: o, onChange: (t) => {
        const q = t.target.value, F = T({
          value: q,
          maskType: s
        });
        t.target.value = F, n && n(t);
      }, onKeyUp: (t) => {
        t.key === "Tab" && g(!1);
      }, onClick: () => g(!0) }),
      f && /* @__PURE__ */ e(z, { children: f }),
      u && !c && /* @__PURE__ */ e(b, { icon: "NegativeLine" })
    ] }),
    /* @__PURE__ */ e(p, { children: w })
  ] });
});
E.displayName = "RangoInputText";
export {
  E as RangoInputText
};
